import { Circle, Image, Menu, MenuButton, MenuDivider, MenuItem, MenuList } from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBaseUrl } from '../../App';
import { isAuthenticated } from '../../auth/keycloak';
import config from '../../config';
import PageDataContext from '../../context/PageDataContext';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { getUserPrivateProfile, UserPrivateProfile } from '../../service/social';
import { DashboardIcon } from '../iconComponents/DashboardIcon';
import { LogoutIcon } from '../iconComponents/LogoutIcon';
import { ProfileIcon } from '../iconComponents/ProfileIcon';
import { SettingsIcon } from '../iconComponents/SettingsIcon';

export const HeaderMenu: React.FC = () => {
    const { keycloak } = useKeycloak();
    const { isLoadFromCache } = useContext(PageDataContext);
    const navigate = useNavigate();

    const localStoragePrefix = 'HeaderMenu';
    const [userProfile, setUserProfile] = useSessionStorage<UserPrivateProfile | undefined>(
        `${localStoragePrefix}}_userProfile`,
        undefined,
    );

    useEffect(() => {
        async function loadProfileInfo() {
            const profile = await getUserPrivateProfile(
                keycloak.subject || '',
                keycloak.token || '',
            );
            setUserProfile(profile);
        }
        if (!isLoadFromCache && keycloak?.authenticated) {
            loadProfileInfo();
        }
    }, []);

    const renderIcon = () => {
        if (isAuthenticated(keycloak)) {
            return <Image src={userProfile?.avatar_object_url || config.avatarPlaceholderURL} />;
        } else {
            return <ProfileIcon />;
        }
    };

    const renderMenuItems = () => {
        if (isAuthenticated(keycloak)) {
            return (
                <MenuList className={'header-menu-body'}>
                    <MenuItem icon={ProfileIcon()} onClick={() => navigate('/profile')}>
                        My Profile
                    </MenuItem>
                    <MenuItem icon={DashboardIcon()} onClick={() => navigate('/dashboard')}>
                        Dashboard
                    </MenuItem>
                    <MenuDivider />
                    <MenuItem icon={SettingsIcon()} onClick={() => navigate('/settings')}>
                        Settings
                    </MenuItem>
                    <MenuItem
                        icon={LogoutIcon()}
                        onClick={() =>
                            keycloak.logout({
                                redirectUri: window.location.origin,
                            })
                        }
                    >
                        Log Out
                    </MenuItem>
                </MenuList>
            );
        } else {
            return (
                <MenuList className={'header-menu-body'}>
                    <MenuItem
                        icon={ProfileIcon()}
                        onClick={() => keycloak.login({ redirectUri: `${getBaseUrl()}hosts` })}
                    >
                        Sign In
                    </MenuItem>
                    <MenuItem icon={SettingsIcon()} onClick={() => navigate('/settings')}>
                        Settings
                    </MenuItem>
                </MenuList>
            );
        }
    };

    return (
        <Menu>
            {keycloak.authenticated ? (
                <MenuButton className="header-menu-icon header-menu-icon-authenticated">
                    <Circle>{renderIcon()}</Circle>
                </MenuButton>
            ) : (
                <MenuButton className="header-menu-icon">
                    <Circle>{renderIcon()}</Circle>
                </MenuButton>
            )}
            {renderMenuItems()}
        </Menu>
    );
};
